import { render, staticRenderFns } from "./StatusTarefaComponent.vue?vue&type=template&id=3092ac72"
import script from "./StatusTarefaComponent.vue?vue&type=script&lang=js"
export * from "./StatusTarefaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports